import ProfileDetails from "../../slices/users/profile/ProfileDetails";

const usersReducer = {
    profileDetails: ProfileDetails,
};

export default usersReducer;